import { render, staticRenderFns } from "./TableTemplate.vue?vue&type=template&id=0c435776"
import script from "./TableTemplate.vue?vue&type=script&lang=js"
export * from "./TableTemplate.vue?vue&type=script&lang=js"
import style0 from "./TableTemplate.vue?vue&type=style&index=0&id=0c435776&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports